export const education = [
    {
        id: 1,
        title: "Ingeniero Informatico",
        institution: "Instituto Profesional Duoc UC",
        institutionURL: `https://www.duoc.cl/`,
        description: `Titulado como Ingeniero en Informatica`,
        from: "Marzo 2015",
        to: "Diciembre 2019"
    }
]